import Button from 'components/partials/button/button';
import Modal from 'components/partials/modal/modal';

import { TAB_LABELS } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';
import type {
  CaptureListTab,
  DeleteTarget,
} from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.types';
import { useDeleteCapture } from 'containers/admin/clients/client/tabs-components/critical-populations/hooks/use-delete-capture';

interface DeleteModalProps {
  target: DeleteTarget;
  tab: CaptureListTab;
  clientId: number;
  onDeleted: () => void;
  onClose: () => void;
}

const DeleteModal = ({
  target,
  tab,
  clientId,
  onDeleted,
  onClose,
}: DeleteModalProps) => {
  const { isPending, handleConfirm } = useDeleteCapture({
    clientId,
    id: target.id,
    onDeleted,
    onClose,
  });

  const footer = (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="critical-filled"
        size="md"
        loading={isPending}
        onClick={handleConfirm}
        data-testid="delete-modal-confirm"
      >
        Delete
      </Button>
      <Button
        type="button"
        variant="neutral-outlined"
        size="md"
        onClick={onClose}
        data-testid="delete-modal-cancel"
      >
        Cancel
      </Button>
    </div>
  );

  return (
    <Modal
      headerText="Delete Critical Element"
      onCloseCallback={onClose}
      showCloseButton
      disableBackdropClick
      skipUnmountOnClose
      footer={footer}
      primaryAction={{ onClick: handleConfirm, loading: isPending }}
      modalClassName="tablet:w-[640px] p-5 shadow"
      backdropClassName="opacity-40"
      headerClassName="text-2xl font-bold"
      data-testid="delete-modal"
    >
      <p className="text-base text-gray-700">
        <b className="font-semibold">{target.summary}</b> will be permanently removed from{' '}
        {TAB_LABELS[tab]}. This can&apos;t be undone.
      </p>
    </Modal>
  );
};

export default DeleteModal;
